import React, { useEffect } from 'react';
import { StytchLogin } from '@stytch/react';
import { Products } from '@stytch/vanilla-js';
import { useAuth } from './AuthProvider';

function AuthScreen({ onAuthSuccess }) {
  const { user } = useAuth();

  useEffect(() => {
    if (user && onAuthSuccess) {
      onAuthSuccess();
    }
  }, [user, onAuthSuccess]);

  const stytchConfig = {
    products: [Products.emailMagicLinks], // Magic Links instead of OTP
    emailMagicLinksOptions: {
      loginRedirectURL: window.location.origin + '/authenticate',
      loginExpirationMinutes: 30,
      signupRedirectURL: window.location.origin + '/authenticate', 
      signupExpirationMinutes: 30,
    },
  };

  const customStrings = {
    'login.title': ' ',
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-8 sm:py-12 sm:px-4">
      <div className="w-full max-w-sm sm:max-w-md lg:max-w-lg sm:mx-auto">
        <div className="text-center mb-6 sm:mb-8 px-4 sm:px-2">
          <img 
            src="https://supabase.zapt.ai/storage/v1/render/image/public/icons/c7bd5333-787f-461f-ae9b-22acbc0ed4b0/55145115-0624-472f-96b9-d5d88aae355f.png?width=80&height=80" 
            alt="App Traction" 
            className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6"
          />
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Welcome to App Traction</h2>
          <p className="text-gray-600 text-base sm:text-lg px-2">
            Sign in with your email to join the waitlist
          </p>
        </div>

        <div className="bg-white sm:rounded-2xl shadow-xl border border-gray-200 p-0 sm:p-8 px-2">
          <StytchLogin
            config={stytchConfig}
            strings={customStrings}
            styles={{
              container: {
                width: '100%',
                fontFamily: 'system-ui, -apple-system, sans-serif'
              },
              buttons: {
                primary: {
                  backgroundColor: '#7C3AED',
                  borderColor: '#7C3AED',
                  color: '#FFFFFF',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '600',
                  padding: '14px 28px',
                  marginBottom: '16px',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  width: '100%'
                },
                secondary: {
                  backgroundColor: '#FFFFFF',
                  borderColor: '#E5E7EB',
                  color: '#374151',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '500',
                  padding: '14px 28px',
                  marginBottom: '12px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  width: '100%'
                }
              },
              input: {
                backgroundColor: '#FFFFFF',
                borderColor: '#E5E7EB',
                borderRadius: '12px',
                fontSize: '16px',
                padding: '14px 16px',
                marginBottom: '20px',
                border: '2px solid #E5E7EB',
                transition: 'border-color 0.2s',
                outline: 'none',
                width: '100%',
                boxSizing: 'border-box'
              },
              text: {
                color: '#374151',
                fontSize: '14px',
                lineHeight: '1.5'
              }
            }}
            callbacks={{
              onEvent: ({ type, data }) => {
                console.log('Auth event:', { type, data });
                if (type === 'LOGIN_SUCCESS') {
                  console.log('User signed in via magic link');
                }
              },
              onError: (error) => {
                console.error('Auth error:', error);
              },
            }}
          />
        </div>

        {/* Back button */}
        <div className="mt-4 sm:mt-6 text-center px-4 sm:px-2">
          <button 
            onClick={() => window.location.href = '/'}
            className="flex items-center justify-center gap-2 text-gray-500 hover:text-gray-700 transition-colors mx-auto"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <span className="text-sm">Back to Home</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuthScreen; 